<template>
  <HomeWidgetSmall
    :actionButtonHandler="navigateToUserLockouts"
    :hasError="hasError"
    :isLoading="isLoading"
    :metric="totalCount"
    :metricDescription="metricDescription"
    :widgetType="userLockouts"
  />
</template>

<script>
import {
  ItemTypeConsts,
  ItemTypeRoutes,
  StoreModuleMap,
} from 'client/util/Constants';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { mapGetters } from 'vuex';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import HomeWidgetSmall from 'client/HomePageV2/widgets/HomeWidgetSmall';
import SystemUserApi from 'client/api/v2/SystemUserApi';
import SystemUserFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemUserFilters';
import Util from 'client/util/Util';
import pluralize from 'pluralize';

const { userLockouts } = HomeWidgetConsts.widgetTypes;
const systemUserCollection = StoreModuleMap[ItemTypeConsts.systemUser];

const {
  description,
  location,
  section,
  toUrl,
  text: textEventProp,
} = eventProperties;
const {
  homePage,
} = eventLocations;

export default {
  name: 'UserLockoutWidget',
  components: {
    HomeWidgetSmall,
  },

  viewAllRoute: ItemTypeRoutes[ItemTypeConsts.viewUserLockout],

  data: () => ({
    hasError: false,
    isLoading: true,
    totalCount: 0,
    userLockouts,
  }),

  computed: {
    ...mapGetters(systemUserCollection, [
      'getDisplayName',
    ]),

    accountLockedFilter() {
      return SystemUserFilters.locked(true);
    },

    metricDescription() {
      return `${pluralize('user', this.totalCount)} locked out`;
    },
  },

  created() {
    this.handleCreated();
  },

  methods: {
    handleCreated() {
      const sort = '-account_locked_date';
      return SystemUserApi.fetch(null, 3, sort, null, null, [this.accountLockedFilter])
        .then(({ totalCount }) => {
          this.totalCount = totalCount;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    navigateToUserLockouts() {
      EventHelper.triggerWidgetClicked({
        [description]: 'User Lockouts Widget - Home Page',
        [location]: homePage,
        [section]: 'Home Widgets',
        [toUrl]: this.$options.viewAllRoute,
        [textEventProp]: 'User Lockouts',
      });
      Util.redirect(this.$options.viewAllRoute);
    },
  },
};
</script>
